// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2w-1";
export var rateTableServiceLevelDropdown = "_2w-3";
export var rateTableTypeDropdown = "_2w-0";
export var rateTableValueModeDropdown = "_2w-2";